// 接口日志
const sapIntDatapack = {
  reqMsg: '请求消息',
  reqDate: '请求时间',
  respDate: '响应时间',
  respMsg: '响应消息',
  reqDateBegin: '请求开始时间',
  reqDateEnd: '请求结束时间',
  inputDate: '放入时间',
  inputDateBegin: '放入开始时间',
  inputDateEnd: '放入结束时间',
  inputUserNo: '放入人',
  businessType: '业务类型',
  dealStatus: '处理状态',
  dealResult: '处理结果',
  detail: '详情',
  basicInfo: '基本信息',
  requestMsg: '请求消息详情',
  responseMsg: '响应消息详情'
};
export default sapIntDatapack;



// WEBPACK FOOTER //
// ./src/page/log/sapIntDatapack/lang/sapIntDatapack.zh.js